import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const API = `${process.env.REACT_APP_API_BASE_URL}/companies`;

export const createCompany = async (data) => {
  const resp = await axios.post(`${API}`, data);

  return resp.data;
};

export const updateCompany = async (data) => {
  const resp = await axios.patch(`${API}`, data);

  return resp.data;
};

export const addUser = async (data) => {
  const resp = await axios.post(`${API}/users`, data);

  return resp.data;
};

export const deleteUser = async (email) => {
  const resp = await axios.delete(`${API}/users/${email}`);

  return resp.data;
};

export const useCompanies = ({ enabled }) =>
  useQuery({
    queryKey: ['companies'],
    queryFn: async () => {
      const { data } = await axios.get(`${API}`);

      return data;
    },
    enabled
  });
